import PropTypes from 'prop-types';

// ---------------------------------------------------------

import { formatVideoUrl } from './format-video-url';

import styles from './styles.module.scss';
const { video_container, video_player, video_invalid } = styles;

// ---------------------------------------------------------

const Video = ({ url, title }) => {
  const videoUrl = formatVideoUrl(url);

  if (!videoUrl) {
    return (
      <div className={video_invalid}>
        <p>{url ? `Invalid video URL: ${url}` : 'Video URL is missing'}</p>
      </div>
    );
  }

  return (
    <div className={video_container}>
      <iframe
        className={video_player}
        title={title}
        src={videoUrl}
        frameBorder="0"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></iframe>
    </div>
  );
};

Video.propTypes = {
  /**
   * Specifies the title of the video
   */
  title: PropTypes.string,

  /**
   * Specifies the video URL (Provided by Sibcy Cline)
   */
  url: PropTypes.string
};

export default Video;
